import { TooltippedIcon } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { FormInputField, FormInputFieldProps, lt } from '@mews/framework';
import { getTimeUnitPluralTextKeyByServiceTimeClass } from '@mews-commander/utils';
import { WithServiceTimeClass } from '@mews-commander/types';

interface MaximumTimeForPaymentFieldProps extends Partial<WithServiceTimeClass>, Pick<FormInputFieldProps, 'name'> {
    autoFocus?: boolean;
}

export const MaximumTimeForPaymentField = ({ autoFocus, name, serviceTimeClass }: MaximumTimeForPaymentFieldProps) => (
    <FormInputField
        autoFocus={autoFocus}
        size="medium"
        label={lt('PaymentMaximumTime')}
        name={name}
        captionIconWithTooltip={
            <TooltippedIcon size="small" value={IconName.Help} tooltip={TextKey.PaymentMaximumTimeUnitsHint} />
        }
        suffix={serviceTimeClass ? lt(getTimeUnitPluralTextKeyByServiceTimeClass(serviceTimeClass)) : undefined}
        type="number"
    />
);
